import React from "react";

import { StandardFormLayout } from "./StandardFormLayout/StandardFormLayout";
import { Navigation } from "../components/Navigation/Navigation";
import { AnchorNavigation } from "../components/AnchorNavigation/AnchorNavigation";

import Footer from "../components/Footer";
import { Breadcrumb } from "../components/Breadcrumb/Breadcrumb";
import AnchorNavContext from "../components/AnchorNavigation/AnchorNavContext";
import { useAnchorNavStoreInit } from "../lib/hooks/useAnchorNav";

function StandardLayout({
    layoutSettings,
    Hero,
    Content,
    anchorNavData = [],
    anchorNavCameraData,
    mainNavData,
    satelliteNavData,
    breadcrumb,
    config,
    footerData,
    locationState,
    formData,
    children
}) {
    const anchorNavContext = useAnchorNavStoreInit();

    const {
        showNavigation,
        showBreadcrumb,
        showFooter,
        showAnchorNavigation,
        formId
    } = layoutSettings || {};

    if (formId) {
        return (
            <StandardFormLayout
                locationState={locationState}
                formId={formId}
                locale={config.cmsLanguage}
                data={formData}
            >
                {children}
            </StandardFormLayout>
        );
    }

    return (
        <div>
            {mainNavData && showNavigation && (
                <Navigation
                    navData={mainNavData}
                    satelliteNavData={satelliteNavData}
                />
            )}

            <main>
                {showBreadcrumb && <Breadcrumb items={breadcrumb} />}

                {Hero ?? null}

                <AnchorNavContext.Provider value={anchorNavContext}>
                    <div>
                        {showAnchorNavigation && (
                            <AnchorNavigation
                                anchorNavData={anchorNavData}
                                anchorNavCameraData={anchorNavCameraData}
                            />
                        )}

                        {children}

                        {Content ?? null}
                    </div>
                </AnchorNavContext.Provider>
            </main>

            {showFooter && <Footer config={config} footerData={footerData} />}
        </div>
    );
}

export { StandardLayout };
